var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<a class=\"schedule-day-item\" ng-click=\"$ctrl.click()\"> <div class=\"schedule-day-item-full-container\"> <div ng-if=\"$ctrl.available<=0\" class=\"schedule-day-item-full\">{{ 'capacity.full' | i18next }}</div> </div>   <div ng-class=\"{'item_passed': $ctrl.past=='itempast', 'day_item_passed': $ctrl.past=='daypast', 'item_no_capacity': $ctrl.available<=0 || $ctrl.capacity<=0}\"></div> <div ng-if=\"$ctrl.image\" class=\"schedule-day-item-image\" style=\"background-image: url('{{$ctrl.image}}')\"></div> <div class=\"schedule-day-item-content\"> <p class=\"schedule-day-item-title\">{{ $ctrl.title }}</p> <span ng-show=\"$ctrl.time\" class=\"schedule-day-item-time\"> <i class=\"glyphicon glyphicon-time\"></i>\n<b>{{ $ctrl.time }}</b> </span> </div> </a>";
var id1="winresScheduleItem.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresScheduleItem/winresScheduleItem.html
// module id = 488
// module chunks = 2